import { TasOptionsByType } from '@features/offers/utils/tasRelational';

export const MONTHLY_ACQUISITION_ID = '3';
export const MONTHLY_SEASONALITY_ID = '3';

export function buildMonthlyOffer(offer?: {
  fullPrice?: string;
  acquisitionId?: string;
  seasonalityId?: string;
  typeId?: string;
  isFallbackOffer?: boolean;
}) {
  return {
    fullPrice: offer?.fullPrice || '',
    acquisitionId: MONTHLY_ACQUISITION_ID,
    seasonalityId: MONTHLY_SEASONALITY_ID,
    typeId: offer?.typeId || '',
    isFallbackOffer: true,
  };
}

export function hasOfferAnyFilledField(offer?: {
  fullPrice?: string;
  acquisitionId?: string;
  seasonalityId?: string;
  typeId?: string;
}) {
  if (!offer) return false;

  return [
    offer.fullPrice,
    offer.acquisitionId,
    offer.seasonalityId,
    offer.typeId,
  ].some(value => typeof value === 'string' && value.trim().length > 0);
}

export function getMonthlyOptions(baseOptionsByType: TasOptionsByType) {
  return {
    acquisition: baseOptionsByType.acquisition.filter(
      option => option.value === MONTHLY_ACQUISITION_ID
    ),
    seasonality: baseOptionsByType.seasonality.filter(
      option => option.value === MONTHLY_SEASONALITY_ID
    ),
  };
}
